/**
 * reactCommitBudget — React's share of the frame, measured (plan 13 §8).
 *
 * The game UI tree is wrapped in `<Profiler id="game" onRender={onReactCommit}>`
 * (src/game/Game.tsx). Each commit's `actualDuration` lands in
 * FramePhaseBudget as the `react` phase, next to `scene`/`tween`/`render`, so a
 * freeze or frame-budget row says how much of the frame React took. Before
 * this, a HUD that re-rendered on every server patch was invisible to every
 * in-game signal: it shows up only as anonymous scheduler work.
 *
 * React calls `onRender` in development and profiling builds only; in a
 * production build there is simply no `react` phase (and no cost).
 */

import type { ProfilerOnRenderCallback } from 'react';
import { FramePhaseBudget } from './FramePhaseBudget';

let commits = 0;
/** False until React calls onRender at all — i.e. in a production build. */
let profiled = false;

export const onReactCommit: ProfilerOnRenderCallback = (_id, _phase, actualDuration) => {
  profiled = true;
  commits += 1;
  FramePhaseBudget.record('react', actualDuration);
};

/** Commits since the last call (and reset); null when React never reported one. */
export function drainReactCommits(): number | null {
  if (!profiled) return null;
  const n = commits;
  commits = 0;
  return n;
}
